import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_BACK_NODE}/ventas`

export const DescargarExcelVentas = (pedido) => {
  return http.post(`${API_ENDPOINT}/generarExcelVentas`, pedido, {
    responseType: 'blob'
  })
}
